import { form0781HeadingTag, titleWithTag } from '../content';
import {
  manualUploadPageDescription,
  manualUploadPageTitle,
  manualUploadRequirementsTextTitle,
  manualUploadAlertText,
} from '../content/manualUploadPage';
import {
  ancillaryFormUploadUi,
  getAttachmentsSchema,
} from '../../shared/utils/schemas';
import {
  track0781DocumentUploadFailure,
  track0781DocumentUploadSuccess,
} from '../../shared/utils/tracking/form0781Tracking';
import { additionalInfo } from '../../shared/components/fileInputComponent/AdditionalUploadInfo';
import { HINT_TEXT } from '../../shared/components/fileInputComponent/FileInputComponentV1';

const PTSD_781_ATTACHMENT_ID = 'L228';

const base781UploadField = ancillaryFormUploadUi(
  manualUploadRequirementsTextTitle,
  'PTSD 781 form',
  {
    attachmentId: PTSD_781_ATTACHMENT_ID,
    customClasses: 'upload-completed-form',
    isDisabled: true,
    deleteAlertText: manualUploadAlertText,
  },
);

const { parseResponse: baseParseResponse, ...base781UploadOptions } =
  base781UploadField['ui:options'];

export const uiSchema = {
  'ui:title': titleWithTag(manualUploadPageTitle, form0781HeadingTag),
  'ui:description': manualUploadPageDescription,
  'view:howToScanAFile': {
    'ui:description': additionalInfo,
  },
  form781Upload: {
    ...base781UploadField,
    'ui:options': {
      ...base781UploadOptions,
      parseResponse: (response, file) => {
        const parsed = baseParseResponse(response, file);
        track0781DocumentUploadSuccess({
          fileType: file?.type || '',
          fileSize: file?.size,
        });
        return parsed;
      },
      onUploadError: payload => {
        if (payload.status === 'error') {
          track0781DocumentUploadFailure({
            errorMessage: payload.errorMessage,
            fileType: payload.fileType || '',
            fileSize: payload.fileSize,
          });
        }
      },
    },
    'ui:description': HINT_TEXT,
    'ui:confirmationField': ({ formData }) => ({
      data: formData?.map(item => item.name || item.fileName),
      label: 'Uploaded file(s)',
    }),
  },
};

export const schema = {
  type: 'object',
  required: ['form781Upload'],
  properties: {
    'view:howToScanAFile': {
      type: 'object',
      properties: {},
    },
    form781Upload: getAttachmentsSchema(PTSD_781_ATTACHMENT_ID),
  },
};
